import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "p-4 rounded-md gap-6 border text-left border-gray-400 w-5/6 sx:w-11/12 min-h-card shadow-bx" }
const _hoisted_2 = { class: "border-b-2 pb-1 border-boxColor flex items-center gap-8 text-sm" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "" }, " Enter Book Details Below to keep track of your Adventure ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "rounded-sm px-4 py-2 font-medium bg-boxColor text-white text-sm outline-none hover:shadow-typeBox",
  type: "submit"
}, " Add Book ", -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "flex items-start justify-center" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full text-sm grid grid-rows-5 gap-2 mt-2\"><div class=\"text-sm\">Book Title:</div><div class=\"text-sm\">Book Author:</div><div class=\"text-sm\">Book Genre:</div><div class=\"text-sm\">Book Pages:</div></div>", 1)
const _hoisted_8 = {
  key: 0,
  class: "w-full text-sm grid grid-rows-5 gap-2 mt-2"
}
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = {
  key: 0,
  class: "flex w-full gap-3 justify-center mt-3"
}
const _hoisted_14 = {
  key: 1,
  disabled: "",
  class: "rounded cursor-not-allowed px-4 py-2 bg-boxbg text-sm text-black"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "Estimated Time to Finish the Book:", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Current Reading "),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => ($data.modal1 = true)),
        class: "bg-boxbg border-none px-2 py-1 hover:bg-boxColor cursor-pointer hover:text-white"
      }, " Add new book "),
      _createVNode(_component_Card, {
        "modal-1": $data.modal1,
        "onUpdate:modal1": _cache[6] || (_cache[6] = $event => ($data.modal1 = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers((...args) => ($options.createBook && $options.createBook(...args)), ["prevent"])),
            class: "flex flex-col w-auto gap-y-3 bg-white shadow-typeBox px-4 py-6 rounded-md"
          }, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm",
              type: "text",
              placeholder: "Book title e.g purple hibiscus",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.args.bookTitle) = $event))
            }, null, 512), [
              [_vModelText, $data.args.bookTitle]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm",
              type: "text",
              placeholder: "Author e.g chimamanda adichie",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.args.bookAuthor) = $event))
            }, null, 512), [
              [_vModelText, $data.args.bookAuthor]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm",
              type: "text",
              placeholder: "Book Genre",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.args.bookGenre) = $event))
            }, null, 512), [
              [_vModelText, $data.args.bookGenre]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Total pages",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.args.bookPages) = $event)),
              class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm"
            }, null, 512), [
              [_vModelText, $data.args.bookPages]
            ]),
            _hoisted_4
          ], 32)
        ]),
        _: 1
      }, 8, ["modal-1"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        ($options.latestBook)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString($options.latestBook.bookTitle), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString($options.latestBook.bookAuthor), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString($options.latestBook.bookGenre), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString($options.latestBook.bookPages), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      ($options.latestBook)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (!$options.latestBook.completed)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[7] || (_cache[7] = $event => ($options.markAsCompleted($options.latestBook._id))),
                  class: "rounded px-4 py-2 bg-boxColor text-sm text-white"
                }, " Mark as Completed "))
              : (_openBlock(), _createElementBlock("button", _hoisted_14, " Completed ")),
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.fetchPlaylist && _ctx.fetchPlaylist(...args))),
              class: "rounded px-4 py-2 bg-boxColor text-sm text-white"
            }, " Get Music Playlist ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      ($data.estimatedDays || $data.estimatedWeeks)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("p", null, _toDisplayString($data.estimatedDays) + " days or " + _toDisplayString($data.estimatedWeeks) + " weeks", 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}